"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class InsightArticle {
    constructor({ id, url, title, thumbnailImageUrl, }) {
        this.toJSON = () => ({
            id: this.id,
            url: this.url,
            title: this.title,
            thumbnailImageUrl: this.thumbnailImageUrl,
        });
        this.id = id;
        this.url = url;
        this.title = title;
        this.thumbnailImageUrl = thumbnailImageUrl;
    }
}
InsightArticle.fromJSON = (json) => {
    const { id, url, title, thumbnailImageUrl } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof url !== 'string')
        throw new Error('.url must be a string');
    if (typeof title !== 'string')
        throw new Error('.title must be a string');
    if (typeof thumbnailImageUrl !== 'string')
        throw new Error('.thumbnailImageUrl must be a string');
    return new InsightArticle({ id, url, title, thumbnailImageUrl });
};
exports.default = InsightArticle;
